import * as React from "react";
import PermissionGrid from "./components/PermissionGrid";
import PermissionRight from "./components/PermissionRight";
import Equipments from "./components/Equipments";
import CreateDayoffForm from "./components/CreateDayoffForm";
import { useSelector } from "react-redux";
import UpdateDayoffForm from "./components/UpdateDayoffForm";
import DocumentDialog from "../../components/shared/DocumentDialog";

const Person = () => {
  const { createDayoffOpen, updateDayoffOpen, documentDialogOpen } =
    useSelector((state) => state.dialogSlice);
  return (
    <>
      {createDayoffOpen === true && <CreateDayoffForm />}
      {updateDayoffOpen === true && <UpdateDayoffForm />}
      {documentDialogOpen === true && <DocumentDialog />}
      <PermissionGrid />
      <PermissionRight />
      <Equipments />
    </>
  );
};
export default Person;
